import 'bootstrap'

function handlePrintEvents() {
  const printButtons = document.querySelectorAll('.print-button')

  printButtons.forEach((printButton) => {
    printButton.onclick = (event) => {
      print()
    }
  })
}

document.addEventListener('DOMContentLoaded', (event) => {
  handlePrintEvents()
})
